import { Alert, Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../auth'
import { REDIRECT_PORTAL } from '../../user/permission'
import { useRedirectPortal } from '../hooks'

/**
 * Stripe could not collect the last payment and is still trying. The customer keeps their plan and data, but no new
 * candidates come in until the payment method works again.
 */
export function PaymentFailingAlert() {
    const { t } = useTranslation()
    const { can } = useAuth()
    const portal = useRedirectPortal()

    return (
        <Alert
            type="error"
            showIcon
            message={t(
                'We could not collect your last payment. Until you update your payment method, no new candidates come in.'
            )}
            action={
                can(REDIRECT_PORTAL) && (
                    <Button
                        size="small"
                        className="ml-4"
                        loading={portal.isPending}
                        onClick={() => portal.mutateAsync().then((url) => window.open(url))}
                    >
                        {t('Update payment method')}
                    </Button>
                )
            }
        />
    )
}
